import script from "./LessonInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonInvite.vue?vue&type=script&setup=true&lang=js"

import "./LessonInvite.vue?vue&type=style&index=0&id=d281a7c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d281a7c0"]])

export default __exports__